// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   InputAdornment,
//   IconButton,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import ClearIcon from "@mui/icons-material/Clear";
// import { useAuth } from "../../Services/AuthContext";
// import OrganizationService from "../../Services/OrganizationService";

// export default function OrganizationHeader({
//   onCreateClick,
//   onSearch,
//   selectedOrgId,
//   onOrganizationChange,
// }) {
//   const [query, setQuery] = useState("");
//   const [orgList, setOrgList] = useState([]);
//   const { user , loading: authLoading } = useAuth();

//   const roles = user?.roles || [];
//   // console.log("Roles:",roles);
//    const orgIds = user?.organizationIds || [];

//   // debounce search to reduce calls while typing
//   useEffect(() => {
//     const t = setTimeout(() => {
//       onSearch?.(query);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [query, onSearch]);

// useEffect(() => {

//     if (!orgIds || orgIds.length === 0) return;


//     const fetchOrganizationsWithRoles = async () => {
//       try {
//         const responses = await Promise.all(
//           orgIds.map((orgId) =>
//             OrganizationService.getOrganizationbyid(Number(orgId))
//           )
//         );
//         const organizationsData = responses.map((res) => ({
//           organizationId: res.data.organizationId,
//           organizationName: res.data.organizationName,
//           statusId: res.data.statusId,
//         }));
//         setOrgList(organizationsData);
//       } catch (error) {
//         console.error("Failed to fetch organizations", error);
//       }
//     };
//     fetchOrganizationsWithRoles();
//     console.log("Featch:",orgList);
//   }, [user]);
//   return (
//     <Box
//       display="flex"
//       justifyContent="space-between"
//       alignItems="center"
//       mb={2}
//       p={2}
//     >
//       <Typography variant="h5" fontWeight="bold">
//         Organization Admin User Management
//       </Typography>
//       <Box display="flex" gap={2} alignItems="center">
//         <TextField
//           size="small"
//           placeholder="Search user..."
//           value={query}
//           onChange={(e) => setQuery(e.target.value)}
//           InputProps={{
//             endAdornment: query ? (
//               <InputAdornment position="end">
//                 <IconButton size="small" onClick={() => setQuery("")}>
//                   <ClearIcon fontSize="small" />
//                 </IconButton>
//               </InputAdornment>
//             ) : null,
//           }}
//         />
//         {/* <Select
//           size="small"
//           value={selectedOrgId || ""}
//           displayEmpty
//           onChange={(e) => onOrganizationChange?.(e.target.value)}
//           sx={{ minWidth: 200 }}
//         >
//           <MenuItem value="">
//             <em>Select Organization</em>
//           </MenuItem>
//           {orgList.map((org) => (
//             <MenuItem key={org.organizationId} value={org.organizationId}>
//               {org.organizationName}
//             </MenuItem>
//           ))}
//         </Select> */}

//         <Button
//           variant="contained"
//           startIcon={<AddIcon />}
//           sx={{ backgroundColor: "#e76f51" }}
//           onClick={onCreateClick}
//         >
//           Create User
//         </Button>
//       </Box>
//     </Box>
//   );
// }

import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, InputAdornment, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";

export default function OrganizationAdminHeader({ onCreateClick, onSearch }) {
  const [query, setQuery] = useState("");

  // debounce search to reduce calls while typing
  useEffect(() => {
    const t = setTimeout(() => {
      onSearch?.(query);
    }, 300);
    return () => clearTimeout(t);
  }, [query, onSearch]);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} p={2}>
      <Typography variant="h5" fontWeight="bold">
        User Management
      </Typography>

      <Box display="flex" gap={2} alignItems="center">
        <TextField
          size="small"
          placeholder="Search user..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          InputProps={{
            endAdornment: query ? (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setQuery("")}>
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
        />

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ backgroundColor: "#e76f51" }}
          onClick={onCreateClick}
        >
          Create User
        </Button>
      </Box>
    </Box>
  );
}
